"use client";

import { ContainerProvider } from "@pharaday/utils";

import { UnauthenticatedContainer } from "../../core/unauthenticated.container";
import InternalRequestPasswordResetForm from "./InternalRequestPasswordResetForm";

const RequestPasswordResetForm = () => {
  return (
    <ContainerProvider value={UnauthenticatedContainer}>
      <InternalRequestPasswordResetForm />
    </ContainerProvider>
  );
};

export default RequestPasswordResetForm;
